// Owner/pack-reset by GroupedReaderBody. Never persist prose to progress.
export function mergeLessonSession(previous, lessonId, value) {
    return { ...previous, [lessonId]: value };
}
